import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../api";
import { fetchPayroll } from "./store/PayrollDataSlice";
import ConfirmationModal from "../../../components/modelpopup/ConfirmationModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const PayrollTable = ({ data, loading }) => {
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAV1ModalOpen, setIsAV1ModalOpen] = useState(false);
  const [isAV2ModalOpen, setIsAV2ModalOpen] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isApprovingV1, setIsApprovingV1] = useState(false);
  const [isApprovingV2, setIsApprovingV2] = useState(false);
  const dispatch = useDispatch();

  const { successMessage, error } = useSelector((state) => state.payrollData);

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
    }
    if (error) {
      toast.error(error);
    }
  }, [successMessage, error]);

  const handleGenerateClick = (record) => {
    setSelectedRecord(record);
    setIsModalOpen(true);
  };

  const handleConfirmGenerate = async () => {
    setIsGenerating(true);
    if (selectedRecord) {
      try {
        const response = await api.post("/generate-payroll", {
          month: selectedRecord.month,
          year: selectedRecord.year,
        });

        if (response.status === 200) {
          toast.success(response.data.message);
          dispatch(fetchPayroll());
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "An error occurred");
      }
      setIsGenerating(false);
      setIsModalOpen(false);
    }
  };

  const handleApprove = async (record, version) => {
    const apiUrl = version === "v1" ? "/approve-v1" : "/approve-v2";
    const setApprovingState =
      version === "v1" ? setIsApprovingV1 : setIsApprovingV2;
    setApprovingState(true);

    try {
      // const formData = new FormData();
      // formData.append("id", record.payroll.id);
      const response = await api.post(`${apiUrl}/${record.payroll.id}`);
      if (response.status === 200) {
        toast.success(response.data.message);
        dispatch(fetchPayroll());
      }
    } catch (error) {
      console.log(error)
      toast.error(error.response?.data?.message || "An error occurred");
    }

    setApprovingState(false);
    version === "v1" ? setIsAV1ModalOpen(false) : setIsAV2ModalOpen(false);
  };

  // Open Approve V1 modal
  const handleApproveV1Click = (record) => {
    setSelectedRecord(record);
    setIsAV1ModalOpen(true);
    // setIsApprovingV1(true);
  };

  // Open Approve V2 modal
  const handleApproveV2Click = (record) => {
    setSelectedRecord(record);
    setIsAV2ModalOpen(true);
    // setIsApprovingV2(true);
  };

  const columns = [
    {
      title: "Month",
      dataIndex: "month",
      render: (text, record) => (
        <div className="table-avatar">
          <Link to="/profile">{text}</Link>
        </div>
      ),
    },
    {
      title: "Month Name",
      dataIndex: "month_name",
    },
    {
      title: "Year",
      dataIndex: "year",
    },
    {
      title: "Action",
      render: (text, record) => (
        <div className="text-start">
          {record.payroll_status === "pending" && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={`tooltip-${record.id}`}>Generate</Tooltip>}
            >
              <Link
                className="btn btn-icon btn-primary btn-sm"
                to="#"
                onClick={() => handleGenerateClick(record)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  backgroundColor: "#3498db",
                  color: "#fff",
                  fontSize: "18px",
                  border: "none",
                }}
              >
                <i className="fa fa-file-alt" />
              </Link>
            </OverlayTrigger>
          )}

          {record.payroll_status === "generated" && (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {record.approve_v1_button === true && (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-approve-v1-${record.id}`}>
                        Approve V1
                      </Tooltip>
                    }
                  >
                    <Link
                      className="btn btn-icon btn-success btn-sm"
                      to="#"
                      // onClick={() => handleApprove(record, "v1")}
                      onClick={() => handleApproveV1Click(record)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        backgroundColor: "#28a745",
                        color: "#fff",
                        fontSize: "18px",
                        border: "none",
                      }}
                    >
                      <i className="fa fa-check" />
                    </Link>
                  </OverlayTrigger>
                )}

                {record.approve_v2_button === true && (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-approve-v2-${record.id}`}>
                        Approve V2
                      </Tooltip>
                    }
                  >
                    <Link
                      className="btn btn-icon btn-warning btn-sm"
                      to="#"
                      // onClick={() => handleApprove(record, "v2")}
                      onClick={() => handleApproveV2Click(record)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        backgroundColor: "#ffc107",
                        color: "#fff",
                        fontSize: "18px",
                        border: "none",
                      }}
                    >
                      <i className="fa fa-check-double" />
                    </Link>
                  </OverlayTrigger>
                )}
              </div>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="table-responsive">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            rowKey="id"
            pagination={{
              pageSize: 10, // Keep a fixed number of items per page
              showSizeChanger: false, // Hide the "per page" dropdown
            }}
          />

          {/* Generate Payroll Confirmation Modal */}
          <ConfirmationModal
            title="Generate Payroll"
            message={`Are you sure you want to generate payroll for ${selectedRecord?.month_name} ${selectedRecord?.year}?`}
            visible={isModalOpen}
            onConfirm={handleConfirmGenerate}
            onCancel={() => setIsModalOpen(false)}
            confirmText="Generate"
            cancelText="Cancel"
            isLoading={isGenerating}
          />

          {/* Approve V1 Confirmation Modal */}
          <ConfirmationModal
            title="Approve V1"
            message={`Are you sure you want to approve payroll version 1 for ${selectedRecord?.month_name} ${selectedRecord?.year}?`}
            visible={isAV1ModalOpen}
            onConfirm={() => handleApprove(selectedRecord, "v1")} // Confirm Approve V1
            onCancel={() => setIsAV1ModalOpen(false)} // Close modal
            confirmText="Approve"
            cancelText="Cancel"
            isLoading={isApprovingV1}
          />

          {/* Approve V2 Confirmation Modal */}
          <ConfirmationModal
            title="Approve V2"
            message={`Are you sure you want to approve payroll version 2 for ${selectedRecord?.month_name} ${selectedRecord?.year}?`}
            visible={isAV2ModalOpen}
            onConfirm={() => handleApprove(selectedRecord, "v2")} // Confirm Approve V2
            onCancel={() => setIsAV2ModalOpen(false)} // Close modal
            confirmText="Approve"
            cancelText="Cancel"
            isLoading={isApprovingV2}
          />
        </div>
      </div>
    </div>
  );
};

export default PayrollTable;

//Download payslip
